import type { CategoryItem } from './category';

export const brandWithImage: CategoryItem[] = [
  {
    name: 'Anua',
    url: '/brand/anua/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/1.png',
    imageAlt: 'Anua',
  },
  {
    name: 'Centellian24',
    url: '/brand/centellian24/',
    imageUrl: 'https://upload.skin-seoul.com/wp-content/uploads/2024/08/centellian24.png',
    imageAlt: 'Centellian24',
  },
  {
    name: 'Beauty of Joseon',
    url: '/brand/beauty-of-joseon/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/3.png',
    imageAlt: 'Beauty of Joseon',
  },
  {
    name: 'COSRX',
    url: '/brand/cosrx/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/5.png',
    imageAlt: 'COSRX',
  },
  {
    name: 'Dr. Jart+',
    url: '/brand/dr-jart/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/6.png',
    imageAlt: 'Dr. Jart+',
  },
  {
    name: 'Dr.G',
    url: '/brand/dr-g/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/7.png',
    imageAlt: 'Dr.G',
  },
  {
    name: 'ETUDE',
    url: '/brand/etude/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/8.png',
    imageAlt: 'ETUDE',
  },
  {
    name: 'Haruharu WONDER',
    url: '/brand/haruharu-wonder/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/10.png',
    imageAlt: 'Haruharu WONDER',
  },
  {
    name: 'Holika Holika',
    url: '/brand/holika-holika/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/11.png',
    imageAlt: 'Holika Holika',
  },
  {
    name: 'ILLIYOON',
    url: '/brand/illiyoon/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/12.png',
    imageAlt: 'ILLIYOON',
  },
  {
    name: 'INNISFREE',
    url: '/brand/innisfree/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/13.png',
    imageAlt: 'INNISFREE',
  },
  {
    name: 'IOPE',
    url: '/brand/iope/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/14.png',
    imageAlt: 'IOPE',
  },
  {
    name: 'Isntree',
    url: '/brand/isntree/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/15.png',
    imageAlt: 'Isntree',
  },
  {
    name: 'KAHI',
    url: '/brand/kahi/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/16.png',
    imageAlt: 'KAHI',
  },
  {
    name: 'LANEIGE',
    url: '/brand/laneige/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/17.png',
    imageAlt: 'LANEIGE',
  },
  {
    name: 'nooni',
    url: '/brand/nooni/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/11/NOONI-Brand-Logos.png',
    imageAlt: 'nooni',
  },
  {
    name: 'MAY COOP',
    url: '/brand/may-coop/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/18.png',
    imageAlt: 'MAY COOP',
  },
  {
    name: 'MEDIHEAL',
    url: '/brand/mediheal/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/19.png',
    imageAlt: 'MEDIHEAL',
  },
  {
    name: 'MISSHA',
    url: '/brand/missha/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/20.png',
    imageAlt: 'MISSHA',
  },
  {
    name: 'Pyunkang Yul',
    url: '/brand/pyunkang-yul/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/21.png',
    imageAlt: 'Pyunkang Yul',
  },
  {
    name: 'ROUND LAB',
    url: '/brand/round-lab/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/22.png',
    imageAlt: 'ROUND LAB',
  },
  {
    name: 'SIDMOOL',
    url: '/brand/sidmool/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/23.png',
    imageAlt: 'SIDMOOL',
  },
  {
    name: 'SKIN1004',
    url: '/brand/skin1004/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/skin1004.png',
    imageAlt: 'SKIN1004',
  },
  {
    name: 'SKINFOOD',
    url: '/brand/skinfood/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/25.png',
    imageAlt: 'SKINFOOD',
  },
  {
    name: 'SOME BY MI',
    url: '/brand/some-by-mi/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/26.png',
    imageAlt: 'SOME BY MI',
  },
  {
    name: 'Sulwhasoo',
    url: '/brand/sulwhasoo/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/27.png',
    imageAlt: 'Sulwhasoo',
  },
  {
    name: 'TONYMOLY',
    url: '/brand/tonymoly/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/28.png',
    imageAlt: 'TONYMOLY',
  },
  {
    name: 'Torriden',
    url: '/brand/torriden/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/02/29.png',
    imageAlt: 'Torriden',
  },
  {
    name: 'AESTURA',
    url: '/brand/aestura/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/09/30.webp',
    imageAlt: 'AESTURA',
  },
  {
    name: 'AMPLE:N',
    url: '/brand/amplen/',
    imageUrl: 'https://skin-seoul.com/wp-content/uploads/2024/09/31.webp',
    imageAlt: 'AMPLE:N',
  },
];
